import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';

var _excluded = ["label", "value"];
var DefaultItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
    value = _ref.value,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _objectSpread2({
    ref: ref
  }, others), label || value);
});

export { DefaultItem };
//# sourceMappingURL=DefaultItem.js.map
